<!--
 * @Author: HTT httishere0728@gmail.com
 * @Date: 2023-06-15 12:54:29
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2023-06-30 21:57:01
 * @FilePath: /notion-widgets-site/src/components/Plus.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="item">
    <div class="left">
      <div class="block">
        <template v-if="type !== 'all'">
          <el-avatar class="avatar" :size="50" :src="logos[type]"></el-avatar>
        </template>
        <template v-else>
          <el-avatar
            class="avatar"
            :size="50"
            :src="logos['flowus']"
          ></el-avatar>
          <el-avatar
            class="avatar"
            fit="contain"
            :size="50"
            :src="logos['notion']"
          ></el-avatar>
        </template>
      </div>
      <!-- <h4>{{ title }}</h4> -->
      <div class="price">
        ¥ {{ realPrice }} <em v-show="originPrice">¥ {{ originPrice }}</em>
      </div>
      <a target="_blank" :href="!isExpired ? coupon : product">
        <el-button
          type="primary"
          class="box-btn"
          data-splitbee-event="Purchase VIP in mobile"
          :data-splitbee-event-product="title"
          :data-splitbee-event-price="realPrice"
          :data-splitbee-event-off="off"
          >成为会员</el-button
        >
      </a>
    </div>
    <div class="rights-box">
      <p v-for="right in rights" :key="right">✔︎ {{ right }}</p>
    </div>
    <!-- out flow -->
    <el-dialog
      :title="`Join us - ${title}`"
      :visible.sync="dialogVisible"
      width="30%"
    >
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["title", "type", "price", "off", "rights", "isExpired"],
  data() {
    return {
      logos: {
        flowus: require("../assets/logos/FlowUs.png"),
        notion: require("../assets/logos/notion-logo.png"),
      },
      coupon:
        "https://pages.tmall.com/wow/a/act/tmall/dailygroup/16355/16802/wupr?wh_pid=daily-465056&disableNav=YES&status_bar_transparent=true&sellerId=1586622315&activityId=462b0b9b3c6f469584a684677061d03d&toolName=itemCoupon",
      product: "https://item.taobao.com/item.htm?ft=t&id=722601465247",
      dialogVisible: false,
    };
  },
  computed: {
    realPrice() {
      const { off, price, isExpired } = this;
      if (!isExpired && off && off > 0) {
        return price - off;
      }
      return price;
    },
    originPrice() {
      const { off, price, isExpired } = this;
      if (!isExpired && off && off > 0) {
        return price;
      } else {
        return null;
      }
    },
  },
  methods: {
    handlePlus() {
      const { isExpired, coupon, product } = this;
      window.open(!isExpired ? coupon : product);
    },
  },
};
</script>
<style lang="less" scoped>
.item {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 10px;
  // min-height: 460px;
  display: flex;
  justify-content: space-between;
  h4 {
    margin: 10px 0;
  }
}
.avatar {
  background-color: #fff;
}
.price {
  color: rgb(175, 35, 28);
  font-size: 36px;
  em {
    color: #333;
    font-size: 20px;
    text-decoration: line-through;
  }
}
.left {
  width: 200px;
}
.rights-box {
  text-align: left;
  font-size: 20px;
  padding: 0 20px;
  width: 150px;
  p {
    font-size: 14px;
  }
}

.box-btn {
  width: 80%;
}
</style>
